import { showNotification } from 'sonata-react-components';

import { MAX_SUBDOMAINS_PER_LIST } from './genericEntries.helper';

import type { IntlShape } from 'react-intl';

type Params = {
  /** Entries discarded because they are not a valid domain or subdomain. */
  invalidCount: number;
  /** Subdomains discarded because the list limit was reached. */
  skippedSubdomains: number;
};

/** Warns about the entries that could not be added to the generic lists (invalid ones and the over-limit ones). */
export const notifyGenericEntriesResult = (
  formatMessage: IntlShape['formatMessage'],
  { invalidCount, skippedSubdomains }: Params
): void => {
  if (invalidCount) {
    showNotification(
      'warning',
      formatMessage(
        {
          defaultMessage:
            '{count, plural, one {# entry was not added because it is not valid.} other {# entries were not added because they are not valid.}}',
          id: 'appAndSiteMarketplace.inventory.invalidEntries'
        },
        { count: invalidCount }
      )
    );
  }
  if (skippedSubdomains) {
    showNotification(
      'warning',
      formatMessage(
        {
          defaultMessage:
            'The limit is {limit} subdomains per list. {count, plural, one {# subdomain was not added.} other {# subdomains were not added.}}',
          id: 'appAndSiteMarketplace.inventory.subdomainsLimit'
        },
        { count: skippedSubdomains, limit: MAX_SUBDOMAINS_PER_LIST }
      )
    );
  }
};
